import filterMFError from '@/shared/sentry/middlewares/filter-mf-error.middleware';
import ignoreChunkErrors from '@/shared/sentry/middlewares/ignore-chunk-error.middleware';

export interface PriorityMiddleware<T> {
  middleware: () => T | null;
  shouldTerminate?: (result: T | null) => boolean;
  priority: number;
}

function applyMiddleware<T>(middlewares: PriorityMiddleware<T>[]): T | null {
  const sorted = [...middlewares].sort((a, b) => b.priority - a.priority);

  let result = null;

  for (const { middleware, shouldTerminate } of sorted) {
    result = middleware();

    if (shouldTerminate && shouldTerminate(result)) {
      break;
    }

    if (!result) {
      break;
    }
  }

  return result;
}

export { applyMiddleware, filterMFError, ignoreChunkErrors };
